<template>
  <main-sidebar :name="name" :title="$t('recipient')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="form.client"
            :options="clientList"
            class="w-full"
            :reduce="(client) => client.ClientId"
            label="ClientName"
            :disabled="isEditing"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('name') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input v-model="form.name" name="name" autocomplete="off" class="w-full" />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('email') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
         <vs-input v-model="form.email" name="email" autocomplete="off" class="w-full" />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.notifyInvoicing">{{
            $t('notify_invoicing')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.notifySCA">{{
            $t('notify_sca')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.notifyAgeing">{{
            $t('notify_ageing')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.notifyOpenExpenses">{{
            $t('notify_open_expenses')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.cc">{{
            $t('cc')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.notifyFunding">{{
            $t('notify_funding')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
        <vs-checkbox v-model="form.notifyShelterFee">{{
            $t('notify_shelter_fee')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="submit">
        {{ $t('submit') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import validate from '@/mixins/Validate.js'

export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.submit
    },
    isEditing() {
      return Object.keys(this.recipient).length !== 0
    },
  },
  data: () => ({
    name: 'recipient-sidebar',
    loading: {
      submit: false,
    },
    form: {
      client: '',
      name: '',
      email: '',
      notifyInvoicing:false,
      notifySCA:false,
      notifyAgeing:false,
      notifyOpenExpenses:false,
      cc:false,
      notifyFunding:false,
      notifyShelterFee:false
    },
  }),
  methods: {
    clear() {
      this.form.client = ''
      this.form.name = ''
      this.form.email = ''
      this.form.notifyInvoicing = false
      this.form.notifySCA = false
      this.form.notifyAgeing = false
      this.form.notifyOpenExpenses = false
      this.form.cc = false
      this.form.notifyFunding = false
      this.form.notifyShelterFee = false
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.clear()
      if (this.isEditing) {
        this.form.client = this.recipient.client_id
        this.form.name = this.recipient.Name
        this.form.email = this.recipient.Email
        this.form.notifyInvoicing = this.recipient.NotifyInvoicing !== '1' ? false : true
        this.form.notifySCA = this.recipient.NotifySCA !== '1' ? false : true
        this.form.notifyAgeing = this.recipient.NotifyAgeing !== '1' ? false : true
        this.form.notifyOpenExpenses = this.recipient.NotifyOpenexpenses !== '1' ? false : true
        this.form.cc = this.recipient.Cc !== '1' ? false : true
        this.form.notifyFunding = this.recipient.NotifyFunding !== '1' ? false : true
        this.form.notifyShelterFee = this.recipient.NotifyShelterFee !== '1' ? false : true
      }
    },
    submit() {
      let action = 'recipient/addRecipient'
      let data = Object.assign({}, this.form)
      if (this.isEditing) {
        action = 'recipient/updateRecipient'
        data.id = this.recipient.RecipientId
      }
      this.loading.submit = true
      this.$store
        .dispatch(action, data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added',
          })
          this.loading.submit = false
          this.close()
          this.$emit('search')
        })
        .catch((res) => {
          this.loading.submit = false
          this.displayErrors(res)
        })
    },
  },
  mixins: [loading, validate],
  props: {
    clientList: {
      type: Array,
      default: () => [],
    },
    recipient: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>